import { useApp } from "../../state/store";
import { useT, type StringKey } from "../../i18n/store";
import type { Dpi } from "../../domain/types";
import { Section } from "../Section";

const DPI_VALUES: Dpi[] = [300, 600, 800, 1200];
const DPI_TO_I18N: Record<Dpi, StringKey> = {
  300: "output.300",
  600: "output.600",
  800: "output.800",
  1200: "output.1200",
};

export const OutputSection = () => {
  const t = useT();
  const output = useApp((s) => s.output);
  const setOutput = useApp((s) => s.setOutput);

  return (
    <Section title={t("section.output")} defaultOpen={false}>
      <div className="row">
        <label>{t("output.dpi")}</label>
        <select
          className="ctl"
          value={output.dpi}
          onChange={(e) => setOutput({ dpi: Number(e.target.value) as Dpi })}
        >
          {DPI_VALUES.map((d) => (
            <option key={d} value={d}>{t(DPI_TO_I18N[d])}</option>
          ))}
        </select>
      </div>
    </Section>
  );
};
